const DEFAULT_LOCALE = 'en-US';
export const resolveFormattingLocale = (language) => {
    const candidate = (language === null || language === void 0 ? void 0 : language.trim().replace('_', '-')) || DEFAULT_LOCALE;
    try {
        return new Intl.DateTimeFormat(candidate).resolvedOptions().locale;
    }
    catch (_a) {
        return DEFAULT_LOCALE;
    }
};
const formatDate = (date, language, options) => {
    const locale = resolveFormattingLocale(language);
    try {
        return new Intl.DateTimeFormat(locale, options).format(date);
    }
    catch (_a) {
        // A malformed or retired time-zone identifier should not break the kiosk.
        // Falling back to the device zone is safer than leaving the clock blank.
        const fallbackOptions = Object.assign({}, options);
        delete fallbackOptions.timeZone;
        return new Intl.DateTimeFormat(locale, fallbackOptions).format(date);
    }
};
export const localeUses24HourTime = (language) => {
    const locale = resolveFormattingLocale(language);
    const parts = new Intl.DateTimeFormat(locale, {
        hour: 'numeric',
        timeZone: 'UTC',
    }).formatToParts(new Date(Date.UTC(2020, 0, 1, 13)));
    return !parts.some((part) => part.type === 'dayPeriod');
};
export const formatLocalizedDate = (date, language, timeZone) => formatDate(date, language, Object.assign(Object.assign({}, (timeZone ? { timeZone } : {})), { weekday: 'long', month: 'long', day: 'numeric' }));
export const formatLocalizedTime = (date, language, timeZone, force24Hour = false) => formatDate(date, language, Object.assign(Object.assign(Object.assign({}, (timeZone ? { timeZone } : {})), { hour: 'numeric', minute: '2-digit' }), (force24Hour ? { hourCycle: 'h23' } : {})));
export const formatLocalizedHour = (value, language, force24Hour = false) => {
    const match = /^(\d{1,2})(?::(\d{2}))?$/.exec(value.trim());
    if (!match)
        return value;
    const hour = Number(match[1]);
    const minute = Number(match[2] || 0);
    if (hour > 23 || minute > 59)
        return value;
    const locale = resolveFormattingLocale(language);
    const use24HourTime = force24Hour || localeUses24HourTime(locale);
    const date = new Date(Date.UTC(2020, 0, 1, hour, minute));
    if (use24HourTime) {
        return formatDate(date, locale, {
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
            timeZone: 'UTC',
        });
    }
    return formatDate(date, locale, Object.assign(Object.assign({ hour: 'numeric' }, (minute ? { minute: '2-digit' } : {})), { hour12: true, timeZone: 'UTC' }));
};
export const selectLocalizedCountLabel = (count, language, singular, plural) => {
    const locale = resolveFormattingLocale(language);
    return new Intl.PluralRules(locale).select(count) === 'one'
        ? singular
        : plural;
};
